<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 md6>
        <div v-if="loading" class="text-center">
          <v-progress-circular indeterminate v-bind:size="50" class="primary--text"/>
        </div>
        <v-flex column v-if="!!page && !loading">
          <v-card>
            <v-card-title primary-title>
              <div class="headline">{{ title }}</div>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="fileHeaders"
                :items="files"
                class="elevation-1"
                hide-default-footer
                no-data-text="Drop files anywhere to upload or click on select files"
              >
                <template v-slot:item.size="{ item }">
                  {{ item.size | formatSize }}
                </template>
                <template v-slot:item.status="{ item }">
                  <v-progress-circular
                    v-if="item.active"
                    :size="24"
                    :rotate="-90"
                    :value="item.progress"
                    color="primary"
                  >
                  </v-progress-circular>
                  <span v-if="item.error === 'size'">
                    File too big
                  </span>
                  <span v-else-if="item.error">
                    <v-icon color="error">highlight_off</v-icon>
                  </span>
                  <span v-else-if="item.success">
                    <v-icon color="primary">check_circle</v-icon>
                  </span>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-tooltip right>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon text color="primary" @click.prevent="$refs.upload.update(item, {active: true, error: '', progress: '0.00'})" :disabled="!item.error">
                        <v-icon>refresh</v-icon>
                      </v-btn>
                    </template>
                    <span>Retry upload</span>
                  </v-tooltip>
                  <v-tooltip right>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon text color="primary" @click.prevent="$refs.upload.remove(item)" :disabled="item.success">
                        <v-icon>clear</v-icon>
                      </v-btn>
                    </template>
                    <span>Remove</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="openFileInput">
                <v-icon left>add</v-icon>
                Select files
              </v-btn>
              <v-btn type="button" class="primary" @click.prevent="upload" :disabled="disableUploadFileBtn" :loading="isUploading">
                <v-icon left>cloud_upload</v-icon>
                Upload
              </v-btn>
                <!--
                <v-btn type="button" class="danger" v-else @click.prevent="$refs.upload.active = false">
                  Stop Upload
                </v-btn> -->

                <file-upload
                  :post-action="postAction"
                  :multiple="true"
                  :size="maxFileSize"
                  v-model="files"
                  @input-filter="inputFilter"
                  @input-file="inputFile"
                  :thread="3"
                  :drop="true"
                  :drop-directory="true"
                  ref="upload">
                </file-upload>
                <div v-show="uploader && uploader.dropActive" class="drop-active">
                  <h3>Drop files to upload</h3>
                </div>
            </v-card-actions>
          </v-card>
          <powered-by-link/>
        </v-flex>
        <v-alert v-if="!page && !loading" :value="true" type="error">
          No form found
        </v-alert>
        <v-card v-if="!page && !loading">
          <v-card-title>
            <span class="headline">To display a form</span>
          </v-card-title>
          <v-card-text>
            Make sure to have the page with a slug, ex: page/demo-docpool-form
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import FileUpload from 'vue-upload-component'
import poweredByLink from '@/components/powered-by-link'

export default {
  name: 'uploadPage',
  data: () => ({
    loading: false,
    files: [],
    fileHeaders: [{
      text: 'Name',
      value: 'name',
      sortable: false
    }, {
      text: 'Size',
      value: 'size',
      sortable: false
    }, {
      text: 'Status',
      value: 'status',
      sortable: false
    }, {
      text: '',
      value: 'action',
      sortable: false
    }],
    uploader: null
  }),
  props: {
    slug: {
      type: String,
      default: ''
    }
  },
  components: {
    FileUpload,
    poweredByLink
  },
  computed: {
    disableUploadFileBtn () {
      return this.files.length <= 0 || this.files.filter(f => !f.success).length <= 0
    },
    hasSlug () {
      return this.slug && this.slug.length > 0
    },
    isUploading () {
      return this.uploader && this.uploader.data.uploading
    },
    maxFileSize () {
      return 1024 * 1024 * 100 // number of Mb
    },
    page () {
      return this.$store.getters.getUploadPage
    },
    postAction () {
      return this.page ? `${process.env.VUE_APP_API_URL}api/pages/${this.page.id}` : ''
    },
    title () {
      return this.page ? this.page.title : ''
    }
  },
  async mounted () {
    if (this.hasSlug) {
      this.loading = true
      try {
        await this.$store.dispatch('loadUploadPage', this.slug)
        this.loading = false
        this.$nextTick(() => {
          this.uploader = this.$refs.upload
        })
      } catch (e) {
        this.loading = false
      }
    }
  },
  methods: {
    openFileInput () {
      document.getElementById('file').click()
    },
    inputFilter (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },
    inputFile (newFile, oldFile) {
      if (newFile && !oldFile) {
        // add
        console.log('add', newFile)
      }
      if (newFile && oldFile) {
        // update
        console.log('update', newFile)
      }
      if (!newFile && oldFile) {
        // remove
        console.log('remove', oldFile)
      }
    },
    upload () {
      this.$refs.upload.active = true
    }
  },
  filters: {
    formatSize: function (size) {
      if (size > 1024 * 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
      } else if (size > 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
      } else if (size > 1024 * 1024) {
        return (size / 1024 / 1024).toFixed(2) + ' MB'
      } else if (size > 1024) {
        return (size / 1024).toFixed(2) + ' KB'
      }
      return size.toString() + ' B'
    }
  }
}
</script>

<style lang="scss" scoped>
.file-uploads {
  padding-top: 7px;
  cursor: pointer !important;
}

.drop-active {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  opacity: .6;
  text-align: center;
  background: #000;

  h3 {
    margin: -.5em 0 0;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 40px;
    color: #fff;
    padding: 0;
  }
}
</style>
